<template>
    <div class="navigator d-flex justify-content-between">
        <div>
            <h2 v-if="getSelectedEventListReservations" class="mr-auto">
                <span>{{filterEventName}}</span>
                <span class="fs-smaller darker ml-2 pointer underlined" @click="removeEventFilter">All activities</span>
            </h2>
            <h2 v-else class="mr-auto">Reservations</h2>
        </div>

        <div class="d-flex align-items-center" v-if="!getSelectedEventListReservations">
            <v-select
                class="mr-3 reservationMainFilter"
                :options="viewOptions"
                v-model="selectedFilters.selectedView"
                label="name"
                @input="viewOptionsChanged">
            </v-select>
            
            <i class="ico ico-calendar fs-large dark mr-3"></i>
            
            <date-picker-new
                :key="pickerKey"
                class="dateRangePicker"
                v-model="selectedFilters.dateRange"
                :range="true"
                :clearOutside="true"
                :showFromTo="false"
                @input="dateRangeChanged">
            </date-picker-new>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import { RESERVATION_LIST_TYPE } from '@/enums/reservationListType'

    import extendedVSelect from '@/extends/vue-select'
    import DatePicker from 'vue2-datepicker'
    import DatePickerNew from '@/tools/DatePicker'

    export default {
        props: {
        },
        data() {
            return {
                viewOptions: [
                    {
                        name: 'Departure date',
                        id: RESERVATION_LIST_TYPE.DEPARTURE_DATE
                    },
                    {
                        name: 'Pickup date',
                        id: RESERVATION_LIST_TYPE.PICKUP_DATE
                    },
                    {
                        name: 'Sales date',
                        id: RESERVATION_LIST_TYPE.SALES_DATE
                    },
                ],
                datePickerShortcuts: [
                    {
                        text: 'Next 7 Days',
                        start: new Date(),
                        end: new Date(Date.now() + 3600 * 1000 * 24 * 7)
                    },
                    {
                        text: 'Next 30 days',
                        start: new Date(),
                        end: new Date(Date.now() + 3600 * 1000 * 24 * 30)
                    }
                ],
                selectedFilters:{
                    selectedView: {
                        name: 'Departure date',
                        id: RESERVATION_LIST_TYPE.DEPARTURE_DATE
                    },
                    dateRange: [
                        moment().startOf('day').format('YYYY-MM-DD'),
                        moment().endOf('day').format('YYYY-MM-DD')
                    ]
                },
                pickerKey: 0,
            }
        },
        created() {
            this.sendFiltersToParent();
        },
        computed: {
            ...mapGetters([
                'getReservations',
                'getListTo',
                'getListFrom',
                'getSelectedEventListReservations'
            ]),
            filterEventName() {
                

                if (!this.getSelectedEventListReservations) return false;

                if (this.getSelectedEventListReservations.nameAlias) return this.getSelectedEventListReservations;
                if (this.getSelectedEventListReservations.product && this.getSelectedEventListReservations.product.name) return this.getSelectedEventListReservations.product.name;

                return 'Event';
            },
        },
        methods: {
            ...mapActions([
                'updateDateRange',
                'openModal',
                'resetNewReservationSetup',
                'resetClonedReservation',
                'getEventFromId',
                'setSelectedEventListReservations',
                'setReservationListType',
                'setBulkSelectedIds',
            ]),
            viewOptionsChanged(e) {
                this.setReservationListType(e.id);
                if (e.id != RESERVATION_LIST_TYPE.DEPARTURE_DATE) {
                    this.setSelectedEventListReservations(null);
                }
                this.sendFiltersToParent();
            },
            dateRangeChanged() {
                this.sendFiltersToParent()
                this.setBulkSelectedIds([])
            },
            sendFiltersToParent() {
                this.$emit('mainFilterChanged', this.selectedFilters);
            },
            removeEventFilter() {
                this.setSelectedEventListReservations(null);
                this.eventHub.$emit('clearReservationFilters');
            }
        },
        components: {
            vSelect: extendedVSelect,
            DatePicker,
            DatePickerNew
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../assets/scss/_variables.scss';
    
    .reservationMainFilter {
        min-width: 170px;
    }

    .dateRangePicker {
        min-width: 250px;
    }
</style>



// WEBPACK FOOTER //
// Navigator.vue?173c1a0c